import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';

export const query = gql`
  query GetWaiverCompanies {
    getWaiverCompanies
  }
`;

export default graphql(query, {
  name: 'companiesData',
  // Skip only if isOpen prop is explicitly false (for WaiverModal)
  // Allow when isOpen is undefined (for Waivers page) or true
  skip: ({ isOpen }) => isOpen === false,
  options: () => ({
    fetchPolicy: 'cache-and-network',
  }),
});
